import React from 'react';
import { motion } from 'framer-motion';
import { BookMockup } from './BookMockup';
export function Solution() {
  const bonuses = [{
    title: '24h Bad Breath Fix',
    subtitle: 'Bonus #1',
    value: '$17',
    image: 'https://cdn.magicpatterns.com/uploads/rYBEiMJ3i1mZHgeAW7B5D3/ChatGPT_Image_May_28,_2026,_07_21_19_PM_(1).png'
  }, {
    title: 'Hollywood White Protocol',
    subtitle: 'Bonus #2',
    value: '$17',
    image: 'https://cdn.magicpatterns.com/uploads/kpoSKbUGebKJ8rW5VoLcqF/ChatGPT_Image_May_28,_2026,_07_18_01_PM.png'
  }, {
    title: 'Sweet Tooth Secret',
    subtitle: 'Bonus #3',
    value: '$16',
    image: 'https://cdn.magicpatterns.com/uploads/rAAXNAKysqkFKhPaGgQQan/ChatGPT_Image_May_28,_2026,_07_19_36_PM_(1).png'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-257">
      <div className="max-w-6xl mx-auto px-6" data-id="element-258">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-259">
          <span className="inline-block bg-sky-100 text-sky-700 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4" data-id="element-260">
            What's Included
          </span>
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-slate-900 mb-4" data-id="element-261">
            What You'll Receive Today
          </h2>
          <p className="text-slate-600 text-lg" data-id="element-262">
            Everything you need to start, plus three helpful bonuses — delivered
            instantly.
          </p>
        </div>

        {/* Main eBook */}
        <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12 mb-10 border border-slate-100" data-id="element-263">
          <div className="flex flex-col lg:flex-row items-center gap-10" data-id="element-264">
            <div className="lg:w-2/5 flex justify-center" data-id="element-265">
              <BookMockup title="The Dental Sugar Hack" subtitle="Digital Guide" size="lg" color="white" image="https://cdn.magicpatterns.com/uploads/4N6DPdPYME5x1S7QhhQ6Ch/heylloyd-image-1780001569319.png" data-id="element-266" />
            </div>
            <div className="lg:w-3/5" data-id="element-267">
              <span className="inline-block bg-orange-100 text-orange-700 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3" data-id="element-268">
                Main eBook
              </span>
              <h3 className="text-2xl md:text-3xl font-playfair font-bold text-slate-900 mb-3" data-id="element-269">
                The Dental Sugar Hack eBook
              </h3>
              <p className="text-slate-600 mb-4 leading-relaxed" data-id="element-270">
                A step-by-step digital guide revealing the science behind sugar,
                oral bacteria, and healthy dental habits.
              </p>
              <div className="text-slate-500 text-sm" data-id="element-271">
                Value: <span className="font-bold text-slate-700" data-id="element-272">$47</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bonuses */}
        <h3 className="text-center text-2xl font-playfair font-bold text-slate-900 mb-10" data-id="element-273">
          Plus 3 Free Bonuses
        </h3>

        <div className="grid md:grid-cols-3 gap-8 mb-10" data-id="element-274">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-white rounded-2xl p-6 shadow-md border border-slate-100 text-center hover:shadow-xl transition-shadow flex flex-col items-center" data-id="element-275">
              <span className="inline-block bg-sky-500 text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-full mb-5" data-id="element-276">
                {bonus.subtitle}
              </span>
              <div className="mb-5" data-id="element-277">
                <BookMockup title={bonus.title} subtitle={bonus.subtitle} size="md" color="white" image={bonus.image} delay={i * 0.15} data-id="element-278" />
              </div>
              <h4 className="font-playfair font-bold text-slate-900 mb-2 leading-tight text-lg" data-id="element-279">
                {bonus.title}
              </h4>
              <div className="text-slate-500 text-sm" data-id="element-280">
                Value:{' '}
                <span className="font-bold text-slate-700" data-id="element-281">{bonus.value}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}